import {createUnencodedQueryString} from './createUnencodedQueryString';


// EX-1209 : Workaround for the filter query string that contains commas and slashes (causing issues
// This can be improved in the future 
// By using the URLSearchParams object
export const createNewUrl = function(searchParams) {
    let query = ``;
    if (searchParams.size != 0) {
        // Get the query string
        query = `?${createUnencodedQueryString(searchParams)}`;


        // Fix unencoded commas or slashes (like "124,5/85 cm")
        // We only target commas between digits in this one
        query = query.replace(/(\d),(\d)/g, '$1%2C$2');

        // Fix unencoded slashes (like "124,5/85 cm")
        query = query.replace(/(\d)\/(\d)/g, '$1%2F$2');

        // Ensure spaces are properly encoded as +
        query = query.replace(/ /g, '+');
    }
    
    return window.location.protocol + '//' +
           window.location.host +
           window.location.pathname +
           query;
};


